import { lazy } from 'react';
import LoginOtp from '@/shahrzad-assets/shared-screens/LoginOtp'
import { sharedPathes } from './pathe'
import Wallet from '../shared-screens/Wallet'
import Layout from '../shared_components/Layout'
const OffVpn = lazy(() => import('../shared-screens/OffVpn'));
const ErrorWallet = lazy(() => import('../shared-screens/ErrorWallet'));
const UseInternet = lazy(() => import('../shared-screens/UseInternet'));
const Error500 = lazy(() => import('../shared-screens/Error500'));
const Error403 = lazy(() => import('../shared-screens/Error403'));
const Error401 = lazy(() => import('../shared-screens/Error401'));
const ErrorPageNotFound = lazy(() => import('../shared-screens/ErrorPageNotFound'));
const Error400 = lazy(() => import('../shared-screens/Error400'));
const Error504 = lazy(() => import('../shared-screens/Error504'));
const Error503 = lazy(() => import('../shared-screens/Error503'));
const Error502 = lazy(() => import('../shared-screens/Error502'));
const ReferralCode = lazy(() => import('@/shahrzad-assets/shared-screens/ReferralCode'));

interface IRoutes {
  path: string
  component: any
  layout: any
  exact: boolean
  navButton?: boolean
}

export const SharedRoutes: Partial<IRoutes>[] = [
  {
    path: sharedPathes.OFF_VPN,
    component: OffVpn,
    exact: true,
  },
  {
    path: sharedPathes.REFERRAL_CODE,
    component: ReferralCode,
    exact: true,
    layout: Layout,
  },
  {
    path: sharedPathes.ERROR_WALLET,
    component: ErrorWallet,
    exact: true,
  },
  {
    path: sharedPathes.NETWORK_FAILE,
    component: UseInternet,
    exact: true,
  },
  {
    path: sharedPathes.ERROR_500,
    component: Error500,
    exact: true,
  },
  {
    path: sharedPathes.ERROR_403,
    component: Error403,
    exact: true,
  },
  {
    path: sharedPathes.ERROR_401,
    component: Error401,
    exact: true,
  },
  {
    path: sharedPathes.ERROR_Page_Not_Found,
    component: ErrorPageNotFound,
    exact: true,
  },
  {
    path: sharedPathes.ERROR_400,
    component: Error400,
    exact: true,
  },
  {
    path: sharedPathes.ERROR_504,
    component: Error504,
    exact: true,
  },
  {
    path: sharedPathes.ERROR_503,
    component: Error503,
    exact: true,
  },
  {
    path: sharedPathes.ERROR_502,
    component: Error502,
    exact: true,
  },
]
